export default __webpack_public_path__ + "static/grafika-2-86de39453ee33de8e2b4a2d22b2a1d98.png";